import gql from 'graphql-tag'
export default class BusinessObject {
  constructor(vue, name, code, dataSourceValue) {
    this.vue = vue
    this.name = name
    this.code = code
    this.dataSourceValue = dataSourceValue
    this.searchValue = null
    this.items = []
    this.comparisonType = {
      like: 'like',
      equal: 'equal'
    }
    this.callActionTimeoutHandler = null
    this.callActionTimeoutTime =  350
  }

  getItems() {
    return this.items
  }

  onAutocompleteCreated(value) {
    if (!value) {
      return
    }
    let strValue = `${value}`
    this.setItems(this.code, this.comparisonType.equal, strValue)
  }

  onAutocompleteInput(searchValue) {
    this.searchValue = searchValue
    if (!searchValue) {
      return
    }
    clearTimeout(this.callActionTimeoutHandler)
    this.callActionTimeoutHandler = setTimeout(() => {
      let value = `%${searchValue}%`
      this.setItems(this.name, this.comparisonType.like, value)
    }, this.callActionTimeoutTime)
  }

  setItems(attribute, comparison, value) {
    this.getBOData({attribute, comparison, value}).then(result => {
      this.items = result
    })
  }

  async getBOData(where) {
    if (!this.vue.$graphqlCore) {
      return []
    }

    let typeName = this.dataSourceValue.charAt(0).toLowerCase() + this.dataSourceValue.slice(1)
    let query = this.getQuery(typeName, this.code, this.name, where)
    let getClient = this.vue.$graphqlCore.getClient
    try {
      const client = await getClient('businessObjects')
      let data = await client.query({
        query: gql`${query}`,
        variables: { value: where.value }
      })
      return data.data[typeName]
    } catch (e) {
      throw new Error(e.message)
    }
  }

  getQuery(typeName, code, text, where) {
    let whereString = ''
    if (where) {
      whereString = `(where: [{attribute: "${where.attribute}", comparison: ${where.comparison}, value: $value}])`
    }
    return `query($value:String){
      ${typeName}${whereString} {
        ${code}
        ${text}
      }
    }`
  }

  initialize () { }
}